import React from 'react';
import { translate } from '../../../Services/translation';

const UserListItemMobile = ({ person }) => {
  return (
    <li className="mb-4 rounded border border-solid border-gray-300 p-4 py-1">
      <p className="mb-3 text-base font-bold capitalize">
        {person.firstName} {person.lastName}
      </p>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        <div className="flex flex-col">
          <p className="text-sm uppercase text-gray-600">
            {translate('mypage.person.email')}:
          </p>
          <p className="text-md">{person.email}</p>
        </div>
        <div className="flex flex-col">
          <p className="text-sm uppercase text-gray-600">
            {translate('mypage.person.phone')}:
          </p>
          <p className="text-md">{person.phone}</p>
        </div>
      </div>
    </li>
  );
};

export default UserListItemMobile;
